import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SingleProduct from "./SingleProduct";
import styled from "styled-components";
import _ from "underscore";
import { fetchJson } from "../../lib/Fetching";

const TinyLink = styled.span`
  color: #5d9cec;
  font-size: 8pt;
  cursor: pointer;
`;

class ProductScheduleList extends React.Component {
  state = {
    products: [],
    selectedProductIds: [],
    selectedSchedulesForProducts: new Map(),
  };

  reloadProduct = (product_id) => {
    fetchJson("/products/products/" + product_id + "/show.json", {}).then((product) => {
      this.setState((state) => ({
        products: state.products.filter((p) => p.id !== product_id).concat(product),
      }));
    });
  };

  // Replace the old product list with the new one, but leave the selected products
  addProducts = (newProducts) => {
    const productsInUse = this.productsInUse();
    this.setState({
      products: newProducts.concat(
        productsInUse.filter(
          (existingProduct) => !newProducts.find((p) => p.id == existingProduct.id)
        )
      ),
    });
  };

  // The products that have been selected or their schedules have been selected
  productsInUse = () => {
    const { products, selectedProductIds, selectedSchedulesForProducts } = this.state;
    return products.filter((product) => {
      return (
        selectedProductIds.indexOf(product.id) >= 0 ||
        (selectedSchedulesForProducts.get(product.id) || []).length > 0
      );
    });
  };

  selectProduct = (product) => {
    const { selectedProductIds } = this.state;
    var newSelectedProductIds;
    if (selectedProductIds.indexOf(product.id) >= 0) {
      newSelectedProductIds = selectedProductIds.filter((id) => id !== product.id);
    } else {
      newSelectedProductIds = selectedProductIds.concat(product.id);
    }
    this.updateSelectedProducts(newSelectedProductIds);
  };

  updateSelectedProducts = (selectedProductIds) => {
    const { updateSelectedProducts } = this.props;
    this.setState({
      selectedProductIds,
    });
    if (updateSelectedProducts) updateSelectedProducts(selectedProductIds);
  };

  updateSelectedSchedulesForProduct = (product, selectedSchedules) => {
    const { updateSelectedSchedules } = this.props;
    const { selectedSchedulesForProducts } = this.state;
    selectedSchedulesForProducts.set(product.id, selectedSchedules);
    this.setState(
      {
        selectedSchedulesForProducts,
      },
      () => {
        if (updateSelectedSchedules) updateSelectedSchedules(this.selectedSchedules());
      }
    );
  };

  selectedSchedules = () => {
    const { selectedSchedulesForProducts } = this.state;
    const productSchedules = [];
    selectedSchedulesForProducts.forEach((schedules, product_id) =>
      schedules.forEach((schedule) => {
        productSchedules.push({
          ...schedule,
          product_id,
        });
      })
    );
    return productSchedules;
  };

  selectAllProducts = () => this.updateSelectedProducts(this.state.products.map((p) => p.id));
  unSelectAllProducts = () => this.updateSelectedProducts([]);

  sortedProducts = () => _.sortBy(this.state.products, "name");

  render() {
    const products = this.sortedProducts();
    const selectedSchedules = this.selectedSchedules();
    const { company_id } = this.props;
    const { selectedProductIds } = this.state;
    return (
      <Fragment>
        <p>
          <TinyLink onClick={this.selectAllProducts}>Select All</TinyLink>{" "}
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <TinyLink onClick={this.unSelectAllProducts}>Un-Select All</TinyLink>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          {products.length} Products &nbsp;&nbsp;|&nbsp;&nbsp;
          {selectedProductIds.length} Selected Products
          <span className="pull-right">{selectedSchedules.length} Selected Schedules</span>
        </p>
        <div className="panel">
          <table className="table table-bordered table-condensed table-dense">
            <thead>
              <tr>
                <th style={{ width: 30 }}>&nbsp;</th>
                <th>{I18n.t("product")}</th>
                <th>Sample Information</th>
                <th>Client Suite</th>
                <th>Client Specification</th>
                <th style={{ width: 35 }} />
                <th style={{ width: 35 }} />
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <SingleProduct
                  selected={selectedProductIds.indexOf(product.id) >= 0}
                  company_id={company_id}
                  key={product.id}
                  product={product}
                  reloadProduct={() => this.reloadProduct(product.id)}
                  selectProduct={this.selectProduct}
                  updateSelectedSchedulesForProduct={this.updateSelectedSchedulesForProduct}
                />
              ))}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}

export default ProductScheduleList;

ProductScheduleList.propTypes = {
  company_id: PropTypes.number,
  updateSelectedSchedules: PropTypes.func,
  updateSelectedProducts: PropTypes.func,
};
